import Player from '@vimeo/player';
import MicroModal from 'micromodal';

const defaultVideoOptions = {
  title: false,
  byline: false,
  portrait: false,
  autopause: false
};

let currentVideoPlayer = null;

/**
 * Setup a button to open a modal that will play a specific video
 *
 * @param {HTMLElement} button The button element that will trigger the modal
 * @param {HTMLElement} video The Vimeo video element to place in the modal
 *
 * @returns {*} no return
 */
export const setupModalVideo = (button, video) => {
  const vID = video.getAttribute('data-vimeo-id');
  const modalContainer = document.querySelector('[data-modal-container]');
  const modalContent = modalContainer.querySelector('[data-modal-content]');
  modalContent.appendChild(video);
  const player = new Player(video, { vID, ...defaultVideoOptions });
  player.ready().then(() => {
    player.setVolume(0.4);
  });

  const onPlayPause = (event) => {
    event.stopImmediatePropagation();
    currentVideoPlayer.getPaused().then((paused) => {
      paused ? currentVideoPlayer.play() : currentVideoPlayer.pause();
    });
    return false;
  };

  const modalOptions = {
    onClose: (modal, element, event) => {
      event.preventDefault();
      event.stopPropagation();
      currentVideoPlayer.pause();
      currentVideoPlayer.setCurrentTime(0);
      playPauseBtn.removeEventListener('click', onPlayPause);
      setTimeout(() => {
        video.style.display = 'none';
      }, 500);
    },
    onShow: () => {
      currentVideoPlayer.play();
    },
    disableScroll: true,
    awaitCloseAnimation: true,
    awaitOpenAnimation: true
  };

  const playPauseBtn = document.querySelector('[data-modal-play-pause-btn]');
  const icon = playPauseBtn.querySelector('.play-pause-btn');

  const onPlay = () => {
    icon.classList.remove('play');
    playPauseBtn.setAttribute('aria-label', 'Pause Video');
  };

  const onPause = () => {
    icon.classList.add('play');
    playPauseBtn.setAttribute('aria-label', 'Play Video');
  };

  player.on('playing', onPlay);
  player.on('pause', onPause);
  player.on('ended', onPause);

  button.addEventListener('click', () => {
    video.style.display = 'block';
    playPauseBtn.style.display = 'block';
    currentVideoPlayer = player;
    playPauseBtn.addEventListener('click', onPlayPause);
    modalContainer.setAttribute('aria-label', 'Featured Video');
    MicroModal.show('content-modal', modalOptions);
  });
};

export const init = () => {
  /**
   * Setup all the video buttons on the page
   * The button and the video element must have the same parent element.
   **/

  const videoButtons = document.querySelectorAll('[data-modal-video-button]');
  videoButtons.forEach((button) => {
    const videoID = button.getAttribute('data-modal-video-button');
    const video = button.parentElement.querySelector(
      `[data-vimeo-id="${videoID}"]`
    );
    if (video) {
      setupModalVideo(button, video);
    }
  });
};
